var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kbtn",class:{'button-is-working':(_vm.isworking === true)},on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('span',[_vm._v(_vm._s(_vm.buttontext))]),(_vm.isworking)?_c('WorkingButtonInsert'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }